import { getDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

// ── Helpers ───────────────────────────────────────────────────────────────────

function fmtN(n) {
  if (n == null) return '—';
  return Number(n).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

function fmtD(d) {
  if (!d) return '—';
  try {
    if (d.toDate) d = d.toDate().toISOString();
    const [y, m, day] = String(d).split('T')[0].split('-');
    return `${day}/${m}/${y}`;
  } catch (e) { return String(d); }
}

function addDays(fechaStr, n) {
  if (!fechaStr) return null;
  const d = new Date(fechaStr);
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

const FORMA_PAGO_MAP = {
  53269: 'Domiciliación SEPA',
  92449: 'Garantía fabricante',
  11: 'Efectivo',
  1: 'Tarjeta',
  2: 'Transferencia bancaria',
  3: 'Bizum',
};
function formaPago(id) {
  return id ? (FORMA_PAGO_MAP[Number(id)] || `Opción ${id}`) : '—';
}

async function getEmpresa() {
  try {
    const snap = await getDoc(doc(db, 'config', 'empresa'));
    if (snap.exists()) return snap.data();
  } catch (e) {}
  return {};
}

// ── CSS compartido ────────────────────────────────────────────────────────────

const CSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  @page { size: A4 portrait; margin: 16mm 14mm 14mm 14mm; }
  body {
    font-family: 'Helvetica Neue', Arial, sans-serif;
    font-size: 10.5pt;
    color: #1a1a1a;
    line-height: 1.45;
    background: #fff;
  }
  /* Botón de impresión */
  .print-btn {
    position: fixed; top: 14px; right: 14px; z-index: 999;
    padding: 9px 20px; background: #dc2626; color: #fff;
    font-weight: 700; font-size: 13px; border: none; border-radius: 8px;
    cursor: pointer; box-shadow: 0 2px 10px rgba(0,0,0,.22);
    display: flex; align-items: center; gap: 7px;
  }
  .print-btn:hover { background: #b91c1c; }
  @media print { .print-btn { display: none !important; } }

  /* Página */
  .page { max-width: 800px; margin: 0 auto; padding: 6px 0; }

  /* Cabecera */
  .header {
    display: flex; justify-content: space-between; align-items: flex-start;
    border-bottom: 3px solid #dc2626; padding-bottom: 16px; margin-bottom: 22px;
  }
  .empresa-nombre { font-size: 20pt; font-weight: 900; color: #dc2626; letter-spacing: -.5px; }
  .empresa-datos  { font-size: 8.5pt; color: #6b7280; margin-top: 5px; line-height: 1.7; }
  .doc-title      { text-align: right; }
  .doc-title h1   { font-size: 20pt; font-weight: 900; color: #374151; text-transform: uppercase; letter-spacing: 1px; }
  .doc-ref        { font-size: 14pt; font-weight: 800; color: #dc2626; margin-top: 3px; }
  .doc-meta       { font-size: 8.5pt; color: #6b7280; margin-top: 5px; line-height: 1.75; }

  /* Secciones */
  .section        { margin-bottom: 18px; }
  .section-title  {
    font-size: 7.5pt; font-weight: 700; text-transform: uppercase;
    letter-spacing: .8px; color: #9ca3af;
    border-bottom: 1px solid #e5e7eb; padding-bottom: 4px; margin-bottom: 9px;
  }
  .info-grid      { display: grid; grid-template-columns: 1fr 1fr; gap: 0 28px; }
  .info-row       { display: flex; gap: 6px; padding: 2.5px 0; font-size: 10pt; }
  .info-label     { color: #6b7280; min-width: 100px; flex-shrink: 0; }
  .info-value     { font-weight: 600; color: #111827; }

  /* Tabla de líneas */
  table           { width: 100%; border-collapse: collapse; font-size: 10pt; }
  thead th        {
    background: #f9fafb; padding: 7px 10px; text-align: left;
    font-size: 8pt; font-weight: 700; text-transform: uppercase;
    letter-spacing: .5px; color: #6b7280;
    border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb;
  }
  thead th.r      { text-align: right; }
  tbody td        { padding: 7px 10px; border-bottom: 1px solid #f3f4f6; vertical-align: top; }
  tbody td.r      { text-align: right; color: #374151; }
  tbody tr:last-of-type td { border-bottom: 1px solid #e5e7eb; }
  .total-row-table { background: #f9fafb; }
  .total-row-table td { font-weight: 800; font-size: 11pt; color: #dc2626; border-bottom: none; }

  /* Bloque de totales */
  .totales        { margin-left: auto; width: 270px; border-top: 2px solid #e5e7eb; padding-top: 10px; }
  .t-row          { display: flex; justify-content: space-between; padding: 3px 0; font-size: 10pt; }
  .t-row .lbl     { color: #6b7280; }
  .t-row .val     { font-weight: 600; }
  .t-final        { border-top: 2px solid #1a1a1a; margin-top: 6px; padding-top: 7px; }
  .t-final .lbl   { font-weight: 800; font-size: 11.5pt; color: #1a1a1a; }
  .t-final .val   { font-weight: 900; font-size: 14pt; color: #dc2626; }

  /* Cajas */
  .box-green { background:#f0fdf4; border:1px solid #bbf7d0; border-radius:8px; padding:11px 15px; margin-top:6px; }
  .box-amber { background:#fef3c7; border:1px solid #fde68a; border-radius:8px; padding:11px 15px; margin-top:6px; }
  .box-notes { background:#fefce8; border:1px solid #fde68a; border-radius:8px; padding:11px 15px; }
  .box-firma { border:1px solid #e5e7eb; border-radius:8px; padding:12px 16px; min-height:90px; }

  /* Pie */
  .pie {
    margin-top: 32px; border-top: 1px solid #e5e7eb; padding-top: 9px;
    font-size: 8pt; color: #9ca3af; text-align: center;
  }
`;

// ── HTML de FACTURA ───────────────────────────────────────────────────────────

function buildFacturaHtml(factura, clienteNombre, empresa) {
  const esAbono = factura.tipo === 'abono';
  const titulo  = esAbono ? 'FACTURA DE ABONO' : 'FACTURA';
  const ref     = factura.referencia || factura.id;
  const cliente = factura.clienteNombre || clienteNombre || '—';
  const vencStr = addDays(factura.fecha, 30);
  const cobro   = factura.cobro;

  const lineas = (factura.lineas || []).map(l => ({
    desc:   l.descripcion || l.nombre || l['item-name'] || l.description || l.name || '',
    ref:    l.referencia || '',
    tipo:   l.tipo || 'material',
    cant:   Number(l.cantidad  || l.quantity || l.units || 1),
    precio: Number(l.precioUnitario || l.unitPrice || l['item-base-price'] || l.price || 0),
  }));
  const totalLineas = lineas.reduce((s, l) => s + l.cant * l.precio, 0);

  const TIPO_ICON = { desplazamiento: '🚗', mano_obra: '🔨', material: '📦' };

  const tablaLineas = lineas.length > 0 ? `
    <table>
      <thead><tr>
        <th>Descripción</th>
        <th class="r">Cant.</th>
        <th class="r">Precio unit.</th>
        <th class="r">Importe</th>
      </tr></thead>
      <tbody>
        ${lineas.map(l => `
          <tr>
            <td>
              ${TIPO_ICON[l.tipo] || '📦'} ${l.desc}
              ${l.ref ? `<br><span style="font-size:8pt;color:#9ca3af;font-family:monospace">${l.ref}</span>` : ''}
            </td>
            <td class="r">${l.cant}</td>
            <td class="r">${l.precio > 0 ? fmtN(l.precio) : '—'}</td>
            <td class="r" style="font-weight:600">${l.precio > 0 ? fmtN(l.cant * l.precio) : '—'}</td>
          </tr>`).join('')}
        ${totalLineas > 0 ? `
          <tr class="total-row-table">
            <td colspan="3" style="text-align:right;padding:8px 10px">TOTAL LÍNEAS</td>
            <td class="r">${fmtN(totalLineas)}</td>
          </tr>` : ''}
      </tbody>
    </table>` : '<p style="color:#9ca3af;font-size:9.5pt;padding:6px 0">Sin líneas de detalle registradas</p>';

  const pctIva = factura.tipoIva ?? 21;
  const base   = factura.importe    ?? null;
  const iva    = factura.importeIva ?? (base != null ? parseFloat((Number(base) * (pctIva / 100)).toFixed(2)) : null);
  const total  = factura.importeTotal ?? (base != null ? parseFloat((Number(base) + (iva ?? 0)).toFixed(2)) : null);

  const totalesHtml = `
    <div class="totales">
      ${base  != null ? `<div class="t-row"><span class="lbl">Base imponible</span><span class="val">${fmtN(base)}</span></div>`  : ''}
      ${iva   != null ? `<div class="t-row"><span class="lbl">IVA (${pctIva}%)</span><span class="val">${fmtN(iva)}</span></div>` : ''}
      <div class="t-row t-final">
        <span class="lbl">${esAbono ? 'TOTAL A DEVOLVER' : 'TOTAL FACTURA'}</span>
        <span class="val">${esAbono ? '-' : ''}${fmtN(total)}</span>
      </div>
    </div>`;

  const cobroHtml = cobro
    ? `<div class="box-green">
        <div style="font-size:8pt;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:#065f46;margin-bottom:7px">✓ Cobro registrado</div>
        <div class="info-row"><span class="info-label">Fecha cobro</span><span class="info-value">${fmtD(cobro.fecha)}</span></div>
        <div class="info-row"><span class="info-label">Importe</span><span class="info-value">${fmtN(cobro.importe)}</span></div>
        <div class="info-row"><span class="info-label">Forma de pago</span><span class="info-value">${formaPago(cobro.formaPagoId)}</span></div>
        ${cobro.reciboRef ? `<div class="info-row"><span class="info-label">Ref. recibo</span><span class="info-value">${cobro.reciboRef}</span></div>` : ''}
      </div>`
    : `<div class="box-amber">
        <span style="font-weight:700;color:#92400e">⏳ Pendiente de cobro</span>
        <span style="color:#92400e;margin-left:12px">Vencimiento: <strong>${fmtD(vencStr)}</strong></span>
      </div>`;

  const abonoOrigenHtml = esAbono && factura.facturaOrigenRef ? `
    <div class="section">
      <div class="section-title">Documento original rectificado</div>
      <div class="info-row"><span class="info-label">Factura origen</span><span class="info-value">${factura.facturaOrigenRef}</span></div>
      ${factura.motivo ? `<div class="info-row"><span class="info-label">Motivo</span><span class="info-value">${factura.motivo}</span></div>` : ''}
    </div>` : '';

  const empDatos = [
    empresa.nif       ? `NIF: ${empresa.nif}` : '',
    empresa.direccion || '',
    empresa.cp && empresa.localidad ? `${empresa.cp} ${empresa.localidad}` : (empresa.localidad || ''),
    empresa.telefono  ? `Tel: ${empresa.telefono}` : '',
    empresa.email     || '',
  ].filter(Boolean).join('<br>');

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <title>${titulo} ${ref}</title>
  <style>${CSS}</style>
</head>
<body>
  <button class="print-btn" onclick="window.print()">🖨 Imprimir / Guardar PDF</button>
  <div class="page">

    <div class="header">
      <div>
        <div class="empresa-nombre">${empresa.nombre || 'Mi Empresa'}</div>
        <div class="empresa-datos">${empDatos}</div>
      </div>
      <div class="doc-title">
        <h1>${titulo}</h1>
        <div class="doc-ref">${ref}</div>
        <div class="doc-meta">
          Fecha emisión: ${fmtD(factura.fecha)}<br>
          ${!esAbono ? `Vencimiento: ${fmtD(vencStr)}<br>` : ''}
          ${factura.metodoPago ? `Forma de pago: ${formaPago(factura.metodoPago)}` : ''}
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">Datos del cliente</div>
      <div class="info-row"><span class="info-label">Nombre / Razón social</span><span class="info-value">${cliente}</span></div>
      ${factura.clienteId ? `<div class="info-row"><span class="info-label">ID / NIF cliente</span><span class="info-value">${factura.clienteId}</span></div>` : ''}
    </div>

    ${abonoOrigenHtml}

    <div class="section">
      <div class="section-title">Detalle de servicios y materiales</div>
      ${tablaLineas}
    </div>

    <div class="section" style="display:flex;justify-content:flex-end">
      ${totalesHtml}
    </div>

    <div class="section">
      <div class="section-title">Estado de pago</div>
      ${cobroHtml}
    </div>

    ${factura.notas ? `
    <div class="section">
      <div class="section-title">Notas</div>
      <div class="box-notes" style="font-size:9.5pt;white-space:pre-wrap">${factura.notas}</div>
    </div>` : ''}

    <div class="pie">
      ${empresa.nombre || 'Mi Empresa'}
      ${empresa.nif ? ` · NIF ${empresa.nif}` : ''}
      · Documento generado el ${new Date().toLocaleDateString('es-ES')}
    </div>
  </div>
</body>
</html>`;
}

// ── HTML de ORDEN ─────────────────────────────────────────────────────────────

function buildOrdenHtml(orden, empresa) {
  const ref    = orden.referencia || orden.id;
  const fecha  = orden.fechaProgramada || orden.fecha
    || (orden.createdAt?.toDate ? orden.createdAt.toDate().toISOString().split('T')[0] : null)
    || orden.createdAt?.split?.('T')?.[0];

  const lineas = (orden.lineas || orden.lines || []).map(l => ({
    tipo:   l.tipo || 'material',
    desc:   l.descripcion || l.nombre || l['item-name'] || l.description || l.name || '',
    ref:    l.referencia || '',
    cant:   Number(l.cantidad || l.quantity || l.units || 1),
    precio: Number(l.precioUnitario || l['item-base-price'] || l.price || 0),
  }));
  const base        = lineas.reduce((s, l) => s + l.cant * l.precio, 0);
  const ivaOrden    = parseFloat((base * 0.21).toFixed(2));
  const totalOrden  = parseFloat((base + ivaOrden).toFixed(2));

  const TIPO_ICON = { desplazamiento: '🚗', mano_obra: '🔨', material: '📦' };

  const tablaLineas = lineas.length > 0 ? `
    <table>
      <thead><tr>
        <th>Descripción</th>
        <th class="r">Cant.</th>
        <th class="r">P. unit.</th>
        <th class="r">Importe</th>
      </tr></thead>
      <tbody>
        ${lineas.map(l => `
          <tr>
            <td>
              ${TIPO_ICON[l.tipo] || '📦'} ${l.desc}
              ${l.ref ? ` <span style="font-size:8pt;color:#9ca3af;font-family:monospace">(${l.ref})</span>` : ''}
            </td>
            <td class="r">${l.cant}</td>
            <td class="r">${l.precio > 0 ? fmtN(l.precio) : '—'}</td>
            <td class="r" style="font-weight:600">${l.precio > 0 ? fmtN(l.cant * l.precio) : '—'}</td>
          </tr>`).join('')}
      </tbody>
    </table>
    ${base > 0 ? `
    <div style="display:flex;justify-content:flex-end;margin-top:8px">
      <div class="totales">
        <div class="t-row"><span class="lbl">Base imponible</span><span class="val">${fmtN(base)}</span></div>
        <div class="t-row"><span class="lbl">IVA (21%)</span><span class="val">${fmtN(ivaOrden)}</span></div>
        <div class="t-row t-final">
          <span class="lbl">TOTAL</span>
          <span class="val">${fmtN(totalOrden)}</span>
        </div>
      </div>
    </div>` : ''}
  ` : '<p style="color:#9ca3af;font-size:9.5pt;padding:6px 0">Sin materiales ni trabajos registrados</p>';

  const firmaHtml = orden.firma
    ? `<div class="box-firma">
        <img src="${orden.firma}" style="max-width:200px;max-height:90px;object-fit:contain" alt="Firma">
      </div>`
    : `<div class="box-firma" style="display:flex;align-items:flex-end;min-height:90px">
        <div style="width:200px;border-top:1px solid #374151;padding-top:4px;font-size:8pt;color:#6b7280;text-align:center">
          Firma y fecha del cliente
        </div>
      </div>`;

  const empDatos = [
    empresa.nif       ? `NIF: ${empresa.nif}` : '',
    empresa.direccion || '',
    empresa.cp && empresa.localidad ? `${empresa.cp} ${empresa.localidad}` : (empresa.localidad || ''),
    empresa.telefono  ? `Tel: ${empresa.telefono}` : '',
    empresa.email     || '',
  ].filter(Boolean).join('<br>');

  const ESTADO_LABEL = {
    pendiente:         'Pendiente',
    en_curso:          'En curso',
    cobrada:           'Cobrada',
    cobrada_sin_firma: 'Cobrada sin firma',
    pendiente_pago:    'Pendiente de pago',
    cerrada:           'Cerrada',
    cancelada:         'Cancelada',
  };

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <title>Orden de servicio ${ref}</title>
  <style>${CSS}</style>
</head>
<body>
  <button class="print-btn" onclick="window.print()">🖨 Imprimir / Guardar PDF</button>
  <div class="page">

    <div class="header">
      <div>
        <div class="empresa-nombre">${empresa.nombre || 'Mi Empresa'}</div>
        <div class="empresa-datos">${empDatos}</div>
      </div>
      <div class="doc-title">
        <h1>ORDEN DE SERVICIO</h1>
        <div class="doc-ref">${ref}</div>
        <div class="doc-meta">
          Fecha: ${fmtD(fecha)}<br>
          Estado: ${ESTADO_LABEL[orden.estado] || orden.estado || '—'}<br>
          ${orden.prioridad ? `Prioridad: ${orden.prioridad}` : ''}
        </div>
      </div>
    </div>

    <div class="info-grid section">
      <div>
        <div class="section-title">Datos del cliente</div>
        <div class="info-row"><span class="info-label">Nombre</span><span class="info-value">${orden.clienteNombre || orden.clientName || '—'}</span></div>
        ${orden.clientePhone || orden.phone ? `<div class="info-row"><span class="info-label">Teléfono</span><span class="info-value">${orden.clientePhone || orden.phone}</span></div>` : ''}
        ${orden.clienteDni ? `<div class="info-row"><span class="info-label">DNI / NIF</span><span class="info-value">${orden.clienteDni}</span></div>` : ''}
        ${orden.clienteId ? `<div class="info-row"><span class="info-label">ID cliente</span><span class="info-value">${orden.clienteId}</span></div>` : ''}
      </div>
      <div>
        <div class="section-title">Intervención</div>
        <div class="info-row"><span class="info-label">Técnico</span><span class="info-value">${orden.tecnicoNombre || '—'}</span></div>
        ${orden.direccion ? `<div class="info-row"><span class="info-label">Dirección</span><span class="info-value">${orden.direccion}</span></div>` : ''}
        ${orden.facturaRef ? `<div class="info-row"><span class="info-label">Factura</span><span class="info-value">${orden.facturaRef}</span></div>` : ''}
      </div>
    </div>

    ${orden.descripcion ? `
    <div class="section">
      <div class="section-title">Descripción del servicio solicitado</div>
      <p style="font-size:10.5pt;line-height:1.6;white-space:pre-wrap">${orden.descripcion}</p>
    </div>` : ''}

    <div class="section">
      <div class="section-title">Materiales y trabajos realizados</div>
      ${tablaLineas}
    </div>

    <div class="info-grid section" style="align-items:start;gap:20px">
      <div>
        <div class="section-title">Observaciones</div>
        ${orden.comentariosPrivados || orden.notas
          ? `<div class="box-notes" style="font-size:9.5pt;white-space:pre-wrap">${orden.comentariosPrivados || orden.notas}</div>`
          : `<div style="min-height:70px;border:1px solid #e5e7eb;border-radius:8px;padding:10px"></div>`}
      </div>
      <div>
        <div class="section-title">Conformidad del cliente</div>
        ${firmaHtml}
        ${orden.clienteDni ? `<p style="font-size:8pt;color:#6b7280;margin-top:5px">DNI cliente: ${orden.clienteDni}</p>` : ''}
        <p style="font-size:8pt;color:#6b7280;margin-top:5px">Fecha: ___________________</p>
      </div>
    </div>

    <div class="pie">
      ${empresa.nombre || 'Mi Empresa'}
      ${empresa.nif ? ` · NIF ${empresa.nif}` : ''}
      · Orden ${ref} · ${new Date().toLocaleDateString('es-ES')}
    </div>
  </div>
</body>
</html>`;
}

// ── Funciones públicas ────────────────────────────────────────────────────────

export async function imprimirFactura(factura, nombreCliente = '') {
  const empresa = await getEmpresa();
  const html    = buildFacturaHtml(factura, nombreCliente, empresa);
  const win     = window.open('', '_blank', 'width=920,height=720');
  win.document.write(html);
  win.document.close();
  setTimeout(() => { try { win.print(); } catch (_) {} }, 700);
}

export async function getFacturaHtml(factura, nombreCliente = '') {
  const empresa = await getEmpresa();
  return buildFacturaHtml(factura, nombreCliente, empresa);
}

export async function imprimirOrden(orden) {
  const empresa = await getEmpresa();
  const html    = buildOrdenHtml(orden, empresa);
  const win     = window.open('', '_blank', 'width=920,height=720');
  win.document.write(html);
  win.document.close();
  setTimeout(() => { try { win.print(); } catch (_) {} }, 700);
}
